export const CONTRACT_CHARGE_TYPES = {
  TUITION: 'tuition',
  TUITION_DISCOUNT: 'tuition_discount',
  TUITION_AID: 'tuition_aid',
  OPTIONAL_FEE: 'optional',
  REQUIRED_FEE: 'required',
  PAYMENT_PLAN_FEE: 'payment_plan',
  DEPOSIT_FEE: 'deposit_fee',
  FINANCIAL_AID_AMOUNT: 'financial_aid_amount',
  SCHOLARSHIP_AMOUNT: 'scholarship_amount'
};

export const DISCOUNT_TYPES = [
  CONTRACT_CHARGE_TYPES.TUITION_DISCOUNT,
  CONTRACT_CHARGE_TYPES.TUITION_AID,
  CONTRACT_CHARGE_TYPES.FINANCIAL_AID_AMOUNT,
  CONTRACT_CHARGE_TYPES.SCHOLARSHIP_AMOUNT
];